import activityTypeDataService = require("../../core/activitytypes.dataservice");
import { Ng2StateDeclaration } from "@uirouter/angular";
import { ActivityTypes } from "./activitytypes.component";
import { EditActivityType } from "./activitytype.edit.component";
import { ActivityType } from "./activitytype.component";

/**
 * This state displays all Activity Types
 */
export const activityTypesState: Ng2StateDeclaration = {
    name: "app.settings.activitytypes",
    url: "/activitytypes",
    views: {
        "main-view@app": {
            component: ActivityTypes
        }
    },
    resolve: {
        activityTypes: ["activityTypeDataService", (activityTypeDataService: activityTypeDataService.IActivityTypeDataService) => {
            return activityTypeDataService.getAll();
        }]
    }
};

/**
 * This state is for creating a new Activity Type
 */
export const newActivityTypeState: Ng2StateDeclaration = {
    name: "app.settings.activitytypes.new",
    url: "/new",
    views: {
        "main-view@app": {
            component: EditActivityType
        }
    },
    resolve: {
        activityType: function () {
            return <Nema.Crew.Model.ActivityType>{ Id: -1, Name: "", Active: true, SortTag: "", Activities: null, IsNormal: false, TimeNorm: null, Color: "", ActivityTypeSummationGroupMappings: null, CompetenceRequirementActivityTypes: null, ManualActivityAdjustments: null };
        },
        isNew: function () {
            return true;
        }
    }
};

/**
 * This state is for editing a Activity Type
 */
export const editActivityTypeState: Ng2StateDeclaration = {
    name: "app.settings.activitytypes.edit",
    url: "/{id:int}/edit",
    views: {
        "main-view@app": {
            component: EditActivityType
        }
    },
    resolve: {
        activityType: ["activityTypeDataService", "$stateParams", function (activityTypeDataService: activityTypeDataService.IActivityTypeDataService, $stateParams) {
            return activityTypeDataService.get($stateParams.id);
        }],
        isNew: function () {
            return false;
        }
    }
};

/**
 * Activity Type Details state
 */
export const activityTypeState: Ng2StateDeclaration = {
    name: "app.settings.activitytypes.detail",
    url: "/{id:int}",
    views: {
        "main-view@app": {
            component: ActivityType
        }
    },
    resolve: {
        activityType: ["activityTypeDataService", "$stateParams", function (activityTypeDataService: activityTypeDataService.IActivityTypeDataService, $stateParams) {
            return activityTypeDataService.get($stateParams.id);
        }]
    }
};


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/activitytypes/activitytypes.states.ts